import { Link } from "react-router-dom";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

export default function Featured() {
  const featured = comics.slice(0, 8);
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="text-sm font-bold text-primary-600">热门推荐</p>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
            人气长篇连载
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            读者口碑最高的长篇连载精品，持续稳定更新，每一部都值得一路追到底。
          </p>
        </div>
        <Link
          to="/series"
          className="hidden whitespace-nowrap items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 sm:flex"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 md:gap-5">
        {featured.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>

      <div className="mt-8 text-center sm:hidden">
        <Link
          to="/series"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          查看全部连载 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}